import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
    updateItemInfo,
    updateNewCategoryImage,
    deleteNewCategoryImage,
    setMultiImageUploadStatus
} from '../../../actions/items';
import toastMessageActions from 'jd-library/toastMessageActions';
import historyHandler from "jd-library/historyHandler";
import config from '../../../../config/config';
const apiDomain = config.apiDomains[0];

import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import ViewImage from '../../ViewImage/ViewImage';
import SliderWrapper from 'jd-library/SliderWrapper';
import axios from 'axios';
import style from './item-cat.scss';

const ParentCat = (props) => {
    let inputRef = useRef(null);
    const [categoryNameToast, updateCategoryNameToast] = useState('');
    const [isScrolled, setScroll] = useState(false);
    const [footerBtnClicked, setFooterBtnClick] = useState(false);
    const imageSlider = useRef(null);
    const handleChange = (e, key) => {
        var tempObj = {};
        tempObj[key] = e.currentTarget.value;
        props.updateItemInfo(tempObj);
        updateCategoryNameToast('');
    }
    const CategoryValidations = () => {
        let isError = false;
        let errorMsg = '';
        if (props.catType == 'parent' && !props.itemInfo.parentCatName) {
            errorMsg = 'Please Enter Parent Category Name';
            isError = true;
        } else if (props.catType == 'child' && !props.itemInfo.childCatName) {
            errorMsg = 'Please Enter Child Category Name';
            isError = true;
        }
        if (isError) {
            updateCategoryNameToast(errorMsg);
            props.showToastMessage({
                showToastMessage: true,
                message: errorMsg,
                duration: 5000,
                type: 'error'
            });
            return false;
        }
        return true;
    }
    const saveCategory = () => {
        if (!CategoryValidations()) {
            return;
        }
        let requestUrl = apiDomain + `/marketplace/products/groups/ajax/createProductGroup.service?`;
        if (props.catType == 'parent') {
            requestUrl += `productGroupName=` + props.itemInfo.parentCatName.trim();
        } else {
            requestUrl += `productGroupName=` + props.itemInfo.childCatName.trim() + `&parentGroupId=` + props.parentGroupId;
        }
        if (props.newCategoryImage[0] && props.newCategoryImage[0].imageUrl) {
            requestUrl += `&imageUrl=` + props.newCategoryImage[0].imageUrl;
        }
        axios.post(requestUrl).then((data) => {
            if(data.data && data.data.isProductGroupExist){
                props.showToastMessage({
                    showToastMessage: true,
                    message: 'This Category Already Exists',
                    duration: 5000
                });
            }else{
                props.getCategoryData();
                props.onHidden();
                props.updateItemInfo({[props.inputKey]:''}, true);
                props.onSaveScroll(data.data);
                historyHandler.closeCurrent();
            }
        })
    }
    useEffect(() => {
        return () => {
            props.setMultiImageUploadStatus(false);
        }
    },[]);

    return (
        <div>
            <SliderWrapper
                header={{
                    heading: props.headerText,
                    variant: 'secondary',
                    className: `${style['item-cat-slider-header']}`,
                    raised: isScrolled
                }}
                onHidden={(e) => {
                    if(!footerBtnClicked){
                        props.updateItemInfo({[props.inputKey]:''});
                    } else {
                        props.deleteNewCategoryImage();
                    }
                    props.onHidden();
                }}
                slider={{
                    className: `${style['item-cat-edit-slider']} ${props.fromVendorWeb ? style['item-cat-slider-web'] : ''}`
                }}
                footer={{
                    btnProps: [{
                        children: 'Save',
                        clickHandler: () => {
                            setFooterBtnClick(true);
                            saveCategory();
                        },
                        size: "lg",
                        className: style["item-cat-footer-btn"]
                    }]
                }}
            >
                <ViewImage
                    ref={imageSlider}
                    canUploadImage={true}
                    imageUrlArr={props.newCategoryImage}
                    updateProductImage={props.updateNewCategoryImage}
                    deleteProductImage={props.deleteNewCategoryImage}
                    hasCustomHandler={true}
                    session={props.session}
                    uploadSingleImage={true}
                    hideAddVideo
                    showToastMessage={props.showToastMessage}
                    type={'itemCategory'}
                    noImgLabel='Add a Category Photo'
                    allowMultipleImages={false}
                    variantId={null}
                    isMobile={props.deviceData.isMobile}
                    imgUploadUrl={`/marketplace/products/ajax/uploadGenericImage.service?supplierId=${props?.permissions?.supplierId || props?.session?.supplierId || null}&module=groups`}
                />
                {(props.catType == 'child' && props.customHTML) &&
                    <div className={style['custom-html-container']}>
                        {props.customHTML}
                    </div>
                }
                <InputWithMovingLabel
                    ref={inputRef}
                    label={props.inputLabel}
                    errorMessage={
                        categoryNameToast
                    }
                    input={{
                        value: props.itemInfo[props.inputKey],
                        onChange: e => { handleChange(e, props.inputKey) },
                        onFocus: () => {
                            setScroll(true);
                            updateCategoryNameToast('');
                        },
                        onBlur: () => setScroll(false)
                    }}
                    holderClass={style['item-cat-input']}
                />
            </SliderWrapper>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        session: state.session,
        deviceData: state.library.deviceData,
        itemInfo: state.items.itemInfo,
        errors: state.items.errors,
        newCategoryImage: state.items.newCategoryImage,
        permissions: state.permissions
    };
};
export default connect(mapStateToProps, {
    updateItemInfo,
    updateNewCategoryImage,
    deleteNewCategoryImage,
	showToastMessage: (payload) => {
		return (dispatch) => {
			dispatch(toastMessageActions.showMessage(payload))
		}
	},
    setMultiImageUploadStatus
})(ParentCat);